import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Pagination } from '../../../models/pagination.model';
import { Paginatable } from '../../../interfaces/pagination.interface';
import { ContentState } from '../../../store/state/content.state';

/**
 * Prefer UI component <u4-paginator>
 * @deprecated
 */
@Component({
    selector: 'u4-cpp-pagination',
    templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit, OnDestroy, Paginatable, OnChanges {
    @Output() pageNumberChange = new EventEmitter();
    @Input() totalResults: number;
    @Input() pageNumber: number;
    @Input() pageSize: number;
    @Input() scrollToTop: boolean;

    public pagination: Pagination = new Pagination();
    public labels: {[key: string]: string} = {};

    private destroy$: Subject<void> = new Subject<void>();

    constructor(private store: Store<ContentState>) {
        this.pagination.currentPage = 1;
    }

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => this.labels = labels);

    }

    ngOnChanges() {
        this.pagination.pageSize = Number(this.pageSize) || 20;
        if (this.totalResults && (this.pagination.totalResults !== this.totalResults || this.pagination.currentPage !== this.pageNumber)) {
            this.pagination.totalResults = this.totalResults;
            this.pagination.currentPage = Number(this.pageNumber) || 1;
            this.setPagination(this.pagination.currentPage);
        }
    }

    setPagination(newPageNumber): void {
        this.pagination.currentPage = newPageNumber as number;
        this.pagination.totalPages = Math.ceil(this.pagination.totalResults / this.pagination.pageSize);
        this.pagination.lastResultCurrentPage = (this.pagination.currentPage * this.pagination.pageSize);
        this.pagination.firstResultCurrentPage = (this.pagination.lastResultCurrentPage - this.pagination.pageSize) + 1;
        if (this.pagination.lastResultCurrentPage > this.pagination.totalResults) {
            this.pagination.lastResultCurrentPage = this.pagination.totalResults;
        }
    }

    goToPage(pageNumber): void {
        this.pageNumberChange.emit(pageNumber);
        this.setPagination(pageNumber);

        if (this.scrollToTop) {
            document
                .querySelector('.cpp-layout__canvas-content')
                .scrollIntoView();
        }
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
